import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { approvalViewAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getApprovalInfoViewData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getApprovalInfoData, param);

    if (data.data === null) {
      yield put(approvalViewAction.loadApprovalInfoViewSuccess(false));
    } else {
      yield put(approvalViewAction.loadApprovalInfoViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(approvalViewAction.loadApprovalInfoViewFail(error));
    yield put(globalFinishLoading());
  }
}
